import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { FavouritesService } from "app/favourites/services/favourites.service";
import { Subscription } from "rxjs-compat/Subscription";

export enum SortingDirection {
  off='off',
  desc='desc',
  asc='asc'
}

@Component({
  selector: "iv-live-preset-header-cell",
  templateUrl: "./preset-header-cell.component.html",
  styleUrls: ["./preset-header-cell.component.scss"],
})
export class PresetHeaderCellComponent implements OnInit {
  @Input() value: any;
  @Input() symbolSort: string = SortingDirection.off;
  @Output() onSymbolSortClick = new EventEmitter<boolean>()
  @Output() onMainSortClicked = new EventEmitter<boolean>()
  public direction: string = SortingDirection.desc;
  public currentPreset = 0;
  public showLoader = false;
  private sub = new Subscription();
  private directionSub = new Subscription();

  constructor(
    private _eref: ElementRef,
    private favouritesService: FavouritesService
  ) {}

  ngOnInit() {
    this.sub = this.favouritesService.currentPreset.subscribe(
      (currentPreset: number) => {
        this.currentPreset = currentPreset;
      }
    );
    this.directionSub = this.favouritesService.presetDirection.subscribe(
      (presetDirection: string) => {
        this.direction = presetDirection;
      }
    );
    this.favouritesService.showDirectionLoader.subscribe(
      (isLoading) => (this.showLoader = isLoading)
    );
    if (this.value.dataField === 'optvol') {
      this.value.description = 'Options Volume is the total number of contracts bought and sold for the previous day, for a particular strike price'
    }
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
    this.directionSub?.unsubscribe();
  }

  @HostListener("mouseover")
  onHover() {
    this._setTipPosition();
  }

  private _setTipPosition() {
    const me = <HTMLElement>this._eref.nativeElement;
    const tip = <HTMLElement>me.querySelector(".tip");
    if (tip) {
      const right = me.getBoundingClientRect().right - window.innerWidth;
      const left = me.getBoundingClientRect().left;
      if (right > 0) {
        tip.style.right = right + "px";
      } else {
        if ((tip.clientWidth - me.clientWidth) / 2 > -right) {
          tip.style.right = 0 + "px";
        } else {
          tip.style.removeProperty("right");
          if (left < 0) {
            tip.style.left = -left + "px";
          } else {
            if (left < (tip.clientWidth - me.clientWidth) / 2) {
              tip.style.left = left + "px";
            } else {
              tip.style.removeProperty("left");
            }
          }
        }
      }
    }
  }

  public toggleDirection(): void {
    if (this.symbolSort !== SortingDirection.off) {
     this.onMainSortClicked.emit(true);
     this.favouritesService.setPresetDirection(this.direction);
     this.favouritesService.setShowDirectionLoader(true);
     return
    }
    if (this.direction === SortingDirection.desc) {
      this.favouritesService.setPresetDirection(SortingDirection.asc);
    } else {
      this.favouritesService.setPresetDirection(SortingDirection.desc);
    }
    this.favouritesService.setShowDirectionLoader(true);
  }

  public toggleSortBySymbol(): void {
    this.onSymbolSortClick.emit(true);
    if(this.symbolSort === SortingDirection.desc) {
      this.favouritesService.setPresetDirection(this.direction);
      this.favouritesService.setShowDirectionLoader(true);
    }
  }
}
